// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /award/custom-list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeAwardCustomListBody,
  typeAwardCustomListOutput200,
} from "../../sdk/award/postAwardCustomList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildAwardCustomListQueryKey(
  payload: typeAwardCustomListBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  return ["post:award:awardCustomList", "svc:contest-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeAwardCustomListOutput200,
    unknown,
    typeAwardCustomListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useAwardCustomList(
  payload: typeAwardCustomListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildAwardCustomListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postAwardCustomList(payload),
    ...resolvedOptions,
  });
}
